import { AllExpressionTypes } from './consts.js';
// @ts-ignore
const _expressionTypes = AllExpressionTypes;
//# sourceMappingURL=types.js.map